export default "./images/survio-3AVvp-assets-server-location.svg";